import axios from "axios"

export const url = axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? "https://admin.btip.be/api/btipadmin/" : "http://192.168.1.8:4000/api/btipadmin/",
})

export const IMAGE_URL = process.env.NODE_ENV === 'production' ? "https://admin.btip.be/images/" : "http://192.168.1.5:4000/images/"
export const GOOGLE_API_KEY = "AIzaSyDr9Y_1lpth59O7eFHJjuUvwblEJaDhJjI"